module.exports = Jsw.skinUrl + "/icons/16/plesk/order-descending.png?c973774da91e3186ce0b188d9d895ef1";